// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"963c8f2f","59":"f602154f","154":"15d30b02","276":"95a258ef","312":"aa8cac57","509":"7b6295e8","938":"de228a44"}[chunkId] + ".chunk.js";
};